class OppleAreaMap {
  data = {
    ctx: null,
    canvasDom: null
  }

  constructor(props) {
    this.createCanvas(props);
    this.init(props);
  }

  async init(props) {
    await this.createBg(props);
    this.createRooms(props);
  }

  async reStore(props) {
    this.data.ctx.clearRect(0, 0, this.data.canvasDom.width, this.data.canvasDom.height);
    this.init(props);
  }

  createCanvas(props) {
    // 获取canvas元素
    const canvas = document.querySelector(props.dom);
    // 获取canvas的上下文
    const ctx = canvas.getContext('2d');
    this.data.ctx = ctx;
    this.data.canvasDom = canvas;
  }

  async createBg(props) {
    return new Promise((resolve, reject) => {
      if (!props.bg) {
        resolve();

        return;
      }
      const bg = props.bg;
      const ctx = this.data.ctx;
      const img = new Image();
      const canvasDom = this.data.canvasDom;
      img.src = bg;

      // 当图片加载完成后，绘制到canvas上
      img.onload = () => {
        this.data.radioProp = {
          w: img.width / canvasDom.offsetWidth,
          h: img.height / canvasDom.offsetHeight
        }
        console.log('img', img.width, img.height, this.data.radioProp);
        
        //背景图
        // ctx.drawImage(img, 0, 0, this.data.canvasDom.offsetWidth, this.data.canvasDom.offsetHeight);

        resolve();
      };
    }); 
  }

  createRooms(props) {
    // 设置图片源地址
    const rooms = props.rooms;
    const ctx = this.data.ctx;
    const radioProp = this.data.radioProp;
    console.log('rooms', rooms);

    ctx.font = '12px Arial';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillStyle = 'black'; // 填充颜色为黑色

    rooms.forEach(room => {
      const positions = room.positions;
      // const count = Math.floor(Math.random() * 4)
      for (let j = 0; j < 4; j++) {
        // if (j > count) continue;
        const offset = j * 1;
        ctx.beginPath();
        ctx.moveTo(Math.floor(positions[0].x / radioProp.w), Math.floor((positions[0].y / radioProp.h) - offset)); // 从第一个点开始画
        ctx.fillStyle = room.color;

        for (var i = 1; i < positions.length; i += 1) {
          ctx.lineTo(Math.floor(positions[i].x / radioProp.w), Math.floor(positions[i].y / radioProp.h) - offset); // 后续的点都连线
        }

        const strokeOpcity = j === 3 ? 0.7 : 0.4;
        // ctx.lineWidth = 1;
        ctx.strokeStyle = `rgba(0, 0, 0, ${strokeOpcity})`;

        ctx.closePath();

        if (j === 3) ctx.fill();
        ctx.stroke();
      }     

      if (props.isNeedText) {
        ctx.fillStyle = 'black'; // 填充颜色为黑色
        ctx.fillText(room.data, positions[0].x / radioProp.w + 10, positions[0].y / radioProp.h + 10);
      }
    })
  }
}

export default OppleAreaMap;